import { firebaseAuth, firebaseFire } from './firebase-config';

export function configureFakeBackend() {

    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };

    let users = [{ id: 1, username: 'test', password: 'test', firstName: 'Test', lastName: 'User', role: 'Admin' }];
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        return new Promise((resolve, reject) => {
            // wrap in timeout to simulate server api call
            setTimeout(() => {
                // console.log("url dentro do fake backend", url);
                let isAuth = false
                if (typeof url === 'string' || url instanceof String) {
                    isAuth = url.includes('/users/authenticate')
                } else {
                    if (url && url.url) {
                        isAuth = url.url.includes('/users/authenticate')
                    }
                }

                // authenticate
                // if (url.endsWith('/users/authenticate') && opts.method === 'POST') {

                if (isAuth && opts.method === 'POST') {
                    // get parameters from post request
                    let params = JSON.parse(opts.body);

                    // find if any user matches login credentials
                    firebaseAuth
                        .signInWithEmailAndPassword(params.username, params.password)
                        .then(user => {
                            if (user.user.uid) {
                                firebaseFire
                                    .collection('usuario')
                                    .where('email', '==', params.username)
                                    .get()
                                    .then(snap => {
                                        snap.forEach(doc => {
                                            let responseJson = {
                                                id: user.user.uid,
                                                username: doc.data().nome,
                                                firstName: doc.data().nome,
                                                cidade: doc.data().cidade,
                                                permissao: doc.data().permissao.toString(),
                                                profissao: doc.data().profissao,
                                                crm: doc.data().crm,
                                                avatarURL: doc.data().avatarURL,
                                                hospital: doc.data().hospital,
                                                email: doc.data().email,
                                                especialidades: doc.data().especialidades,
                                                permissoes: doc.data().permissoes,
                                                secretaria: doc.data().secretaria,
                                                samu: doc.data().samu,
                                                cpf: doc.data().CPF,
                                                ref: doc.ref.path,
                                                consorcioRef: doc.data().consorcioRef ? doc.data().consorcioRef.id : null,
                                                role: doc.data().permissao.toString() === "2" || doc.data().permissao.toString() === "4" ? 'Todos' : 'Admin',
                                                token:
                                                    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNTU1NjgyNTc1LCJleHAiOjE1ODcyMTg1NzUsImF1ZCI6ImNvZGVydGhlbWVzLmNvbSIsInN1YiI6InRlc3QiLCJmaXJzdG5hbWUiOiJIeXBlciIsImxhc3RuYW1lIjoiVGVzdCIsIkVtYWlsIjoidGVzdEBoeXBlci5jb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4ifQ.8qHJDbs5nw4FBTr3F8Xc1NJYOMSJmGnRma7pji0YwB4'
                                            };
                                            resolve({ ok: true, json: () => responseJson });
                                        });
                                    });

                                // resolve({ ok: true, json: () => responseJson });
                            }
                        })

                        .catch(function (error) {
                            // Handle Errors here.

                            var msg = '';
                            if (error.code === 'auth/user-not-found') {
                                reject("Usuário ou senha inválido")

                                let data = {
                                    status: false,
                                    error,
                                    msg: "Usuário ou senha inválido"
                                }
                                reject(data.msg)

                                // DESATIVADO RICARDO - 19-07-2024
                                // NÃO FAZ SENTIDO TENTAR LOCALIZAR O USUÁRIO CASO O LOGIN TENHA FALHADO
                                // USUÁRIO MUITO ANTIGOS QUE NÃO TENHAM AUTH NO FIREBASE, DEVEM TER A AUTENTICAÇÃO REFEITA MANUALMENTE

                                // firebaseFire
                                //     .collection('usuario')
                                //     .where('email', '==', params.username)
                                //     .get()
                                //     .then(snap => {
                                //         snap.forEach(doc => {
                                //             if (doc.exists) {
                                //                 firebaseAuth
                                //                     .createUserWithEmailAndPassword(params.username, params.password)
                                //                     .then(user => {
                                //                         let responseJson = {
                                //                             id: user.user.uid,
                                //                             username: doc.data().nome,
                                //                             firstName: doc.data().nome,
                                //                             cidade: doc.data().cidade,
                                //                             permissao: doc.data().permissao.toString(),
                                //                             profissao: doc.data().profissao,
                                //                             crm: doc.data().crm,
                                //                             avatarURL: doc.data().avatarURL,
                                //                             email: doc.data().email,
                                //                             hospital: doc.data().hospital,
                                //                             secretaria: doc.data().secretaria,
                                //                             cpf: doc.data().CPF,
                                //                             ref: doc.ref.path,
                                //                             consorcioRef: doc.data().consorcioRef ? doc.data().consorcioRef.id : null,
                                //                             role: doc.data().permissao.toString() === "2" || doc.data().permissao.toString() === "4" ? 'Todos' : 'Admin',
                                //                             token:
                                //                                 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNTU1NjgyNTc1LCJleHAiOjE1ODcyMTg1NzUsImF1ZCI6ImNvZGVydGhlbWVzLmNvbSIsInN1YiI6InRlc3QiLCJmaXJzdG5hbWUiOiJIeXBlciIsImxhc3RuYW1lIjoiVGVzdCIsIkVtYWlsIjoidGVzdEBoeXBlci5jb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4ifQ.8qHJDbs5nw4FBTr3F8Xc1NJYOMSJmGnRma7pji0YwB4'
                                //                         };

                                //                         resolve({ ok: true, json: () => responseJson });
                                //                     })
                                //                     .catch(function (error) {
                                //                         // Handle Errors here.
                                //                         reject(error.message)
                                //                         // ...
                                //                     });
                                //             }
                                //             else {
                                //                 let data = {
                                //                     status: false,
                                //                     error,
                                //                     msg: 'Não há registro deste usuário!'

                                //                 }
                                //                 reject(data)
                                //             }
                                //         })

                                //     })
                                //     .catch(error => {
                                //         let data = {
                                //             status: false,
                                //             error,
                                //             msg: 'Não há registro deste usuário!'

                                //         }
                                //         reject(data)
                                //     })
                            }
                            else {
                                switch (error.code) {
                                    case 'auth/app-not-authorized':
                                        msg = "App não autorizado, favor procurar o profissional responsável"
                                        break;
                                    case 'auth/argument-error':
                                        msg = "Argumentos incorretos!"
                                        break;
                                    case 'auth/user-disabled':
                                        msg = "Usuário desativado!"
                                        break;

                                    case 'auth/internal-error':
                                        msg = "Erro interno, favor tentar novamente mais tarde!"
                                        break;
                                    case 'auth/invalid-credential':
                                        msg = 'Credenciais Inválidas'
                                        break;
                                    case 'auth/wrong-password':
                                        msg = 'Senha inválida'
                                        break;
                                    default:

                                        break;
                                }

                            }


                            let data = {
                                status: false,
                                error,
                                msg

                            }
                            reject(data.msg)


                            // ...
                        });
                    // resolve({ ok: true, json: () => responseJson });

                    return;
                }

                // register
                let isRegister = false
                if (typeof url === 'string' || url instanceof String) {
                    isRegister = url.includes('/users/register')
                } else {
                    if (url && url.url) {
                        isRegister = url.url.includes('/users/register')
                    }
                }
                // if (url.endsWith('/users/register') && opts.method === 'POST') {
                if (isRegister && opts.method === 'POST') {
                    // get parameters from post request
                    let params = JSON.parse(opts.body);

                    // add new users
                    let { firstName, lastName } = params.fullname.split(" ");
                    let newUser = { id: users.length + 1, username: firstName, password: params.password, firstName: firstName, lastName: lastName, role: 'Admin' }
                    users.push({ newUser })

                    let responseJson = {
                        id: newUser.id,
                        username: newUser.username,
                        firstName: newUser.firstName,
                        lastName: newUser.lastName,
                        role: newUser.role,
                        token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNTU1NjgyNTc1LCJleHAiOjE1ODcyMTg1NzUsImF1ZCI6ImNvZGVydGhlbWVzLmNvbSIsInN1YiI6InRlc3QiLCJmaXJzdG5hbWUiOiJIeXBlciIsImxhc3RuYW1lIjoiVGVzdCIsIkVtYWlsIjoidGVzdEBoeXBlci5jb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4ifQ.8qHJDbs5nw4FBTr3F8Xc1NJYOMSJmGnRma7pji0YwB4'
                    };
                    resolve({ ok: true, json: () => responseJson });
                    return;
                }

                // forget password
                let isReset = false
                if (typeof url === 'string' || url instanceof String) {
                    isReset = url.includes('/users/password-reset')
                } else {
                    if (url && url.url) {
                        isReset = url.url.includes('/users/password-reset')
                    }
                }
                // if (url.endsWith('/users/password-reset') && opts.method === 'POST') {
                if (isReset && opts.method === 'POST') {
                    // get parameters from post request
                    let params = JSON.parse(opts.body);

                    // find if any user matches login credentials
                    let filteredUsers = users.filter(user => {
                        return user.username === params.username;
                    });

                    if (filteredUsers.length) {
                        let responseJson = {
                            message: "We've sent you a link to reset password to your registered email."
                        };
                        resolve({ ok: true, json: () => responseJson });
                    } else {
                        // else return error
                        reject('Sorry, we could not find any registered user with entered username');
                    }
                    return;
                }

                // get users
                let isUsers = false
                if (typeof url === 'string' || url instanceof String) {
                    isUsers = url.includes('/users')
                } else {
                    if (url && url.url) {
                        isUsers = url.url.includes('/users')
                    }
                }
                // if (url.endsWith('/users') && opts.method === 'GET') {’
                if (isUsers && opts.method === 'GET') {
                    // check for fake auth token in header and return users if valid, this security is implemented server side in a real application
                    if (opts.headers && opts.headers.Authorization === 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNTU1NjgyNTc1LCJleHAiOjE1ODcyMTg1NzUsImF1ZCI6ImNvZGVydGhlbWVzLmNvbSIsInN1YiI6InRlc3QiLCJmaXJzdG5hbWUiOiJIeXBlciIsImxhc3RuYW1lIjoiVGVzdCIsIkVtYWlsIjoidGVzdEBoeXBlci5jb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4ifQ.8qHJDbs5nw4FBTr3F8Xc1NJYOMSJmGnRma7pji0YwB4') {
                        resolve({ ok: true, json: () => users });
                    } else {
                        // return 401 not authorised if token is null or invalid
                        reject('Unauthorised');
                    }

                    return;
                }

                // pass through any requests not handled above
                realFetch(url, opts).then(response => resolve(response));

            }, 500);
        });
    }
}